export default __webpack_public_path__ + "static/media/check.29656710.png";